// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1UZmT","footer":"ModalInfo_footer__2yvXC"};